import ModalStoreProvider from "@/hooks/Modal/ModalStoreProvider";
import { useCompanySettingStore, useGlobalStore } from "@/store/hooks";

import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import OrderManagement from "./components/index";
import OrderTab from "./enum/OrderTab";
import AddressDeliverableStore, { AddressDeliverableStoreContext } from "./store/AddressDeliverableStore";
import FrequentlyOrderSearchCriteriaStore, {
    FrequentlyOrderSearchCriteriaStoreContext,
} from "./store/FrequentlyOrderSearchCriteriaStore";
import OrderManagementStore, { OrderManagementContext } from "./store/OrderManagementStore";

interface ContainerProps {}

const Container: React.FC<ContainerProps> = function (props) {
    const globalStore = useGlobalStore();
    const location = useLocation();
    const [orderManagementStore] = useState(() => new OrderManagementStore(globalStore));
    const urlParams = new URLSearchParams(location.search);
    const [frequentlyOrderSearchCriteriaStore] = useState(() => new FrequentlyOrderSearchCriteriaStore());
    const [addressDeliverableStore] = useState(() => new AddressDeliverableStore(globalStore, false));
    const companySettingStore = useCompanySettingStore();

    const shopId = parseInt(urlParams.get("shopId"), 10);
    let tab = urlParams.get("tab") as OrderTab;
    if (!tab || !OrderTab[tab]) {
        tab = OrderTab.PENDING_SHIPMENT;
    }

    useEffect(() => {
        companySettingStore.ensureCompanySetting();

        globalStore.warehouseWarningStore.load();

        orderManagementStore.storage.ensureQuickTimeSelectConfigs();
    }, []);

    useEffect(() => {
        orderManagementStore.setTab(tab);
    }, [tab]);

    return (
        <OrderManagementContext.Provider value={orderManagementStore}>
            <FrequentlyOrderSearchCriteriaStoreContext.Provider value={frequentlyOrderSearchCriteriaStore}>
                <AddressDeliverableStoreContext.Provider value={addressDeliverableStore}>
                    <ModalStoreProvider>
                        <OrderManagement shopId={shopId} tab={tab} />
                    </ModalStoreProvider>
                </AddressDeliverableStoreContext.Provider>
            </FrequentlyOrderSearchCriteriaStoreContext.Provider>
        </OrderManagementContext.Provider>
    );
};

export default React.memo(Container);
